import React, {useState, Fragment, useEffect} from 'react';
import { nuevoOActualizarRegistroPersonalizado, nuevoOActualizarRegistroPersonalizadoConMetodo, obtenerMunicipiosPersonalizado, obtenerRegistrosPersonalizado, obtenerRegistrosPorURL } from 'store/actions/customAction';
import { alertaPersonalizadaSwal } from 'servicios/AlertasPersonalizados';
import AlertaDeRespuesta from 'components/AlertaDeRespuesta';
import IndicadorDeCarga from 'components/IndicadorDeCarga';
import TituloConImagen from 'components/tituloConImagen';
import ServiciosDelAPI from 'servicios/ServiciosDelAPI';
import { Button, Card, CardContent } from '@mui/material';
import TituloConIcono from 'components/tituloConIcono';
import { Download, NavigateNext, Visibility } from '@mui/icons-material';
import Formulario from 'components/formulario';
import { useHistory } from 'react-router-dom';
import {useDispatch} from 'react-redux';
import { NoAutorizado } from 'commons';
import ModalDeImagen from 'components/ImageModal';
import { declaracionesJuradas } from 'constantes/declaracionesjuradas';
import { functions } from 'constantes';
import { redesSociales } from 'constantes/redesSociales';

let idRedSocial = "";
let datosDeEmpresaGlobal = {}
let plantillaDocumento = "";
const RedesSociales = ({ redSocial}) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const [datosDeRespuesta, setDatosDeRespuesta] = useState({ tipoDeAlerta: 'error', mensajeDeAlerta: '', mostrarRespuesta: false, });
    const[cargandoSolicitud, setcargandoSolicitud] = useState(false);
    const[base64Imagen, setBase64Imagen] = useState("");
    const[mostrarLogo, setMostrarLogo] = useState(false);
    const[fomularioDeRedesSociales] = useState("tarifarioDeRedesSociales");
    const [validarDatos, setValidarDatos] = useState({checkearAutorizacion: false, autorizado: true, cargando: true});

    useEffect( () => {
        consultarRedSocial()
    }, [])

    const consultarRedSocial = async () => {
        setcargandoSolicitud(true);
        const copiaDeCampos = Object.assign({}, camposDelFormulario);

        ServiciosDelAPI[fomularioDeRedesSociales].metodoDeBusqueda.clear();
        let respuesta = await dispatch(obtenerRegistrosPorURL({ controller: fomularioDeRedesSociales, saveInStore: false, action: "listar", nombreDelMetodo: "listar", parametro: `totalRegistros/${redSocial === 'facebook' ? 1 : 2}`}));

        setcargandoSolicitud(false);

        plantillaDocumento = "";
        buttonList.saveData.label = "Guardar datos";
        copiaDeCampos.plantilla.validators.required = true;
        copiaDeCampos.plantilla.disabledVisualization = false;
        idRedSocial = "";
        copiaDeCampos.nombrePagina.value = ""
        copiaDeCampos.urlPagina.value = ""
        copiaDeCampos.correoElectronico.value = ""
        copiaDeCampos.nombreCompleto.value = ""
        copiaDeCampos.cui.value = ""
        copiaDeCampos.plantilla.value = ""

        if(respuesta?.error) {
            setCamposDelFormulario(copiaDeCampos);
            return setDatosDeRespuesta({ tipoDeAlerta: 'error', mensajeDeAlerta: respuesta?.error?.message || "No se encontraron datos", mostrarRespuesta: true, });
        }

        if(respuesta?.data?.length === 0) return setCamposDelFormulario(copiaDeCampos);

        const {nombre, url, email, nombreAdmin, documento, cuiAdmin, id} = respuesta.data[0];
        copiaDeCampos.nombrePagina.value = nombre?.trim() || ""
        copiaDeCampos.urlPagina.value = url?.trim() || ""
        copiaDeCampos.correoElectronico.value = email?.trim() || ""
        copiaDeCampos.nombreCompleto.value = nombreAdmin || ""
        copiaDeCampos.cui.value = cuiAdmin || ""
        copiaDeCampos.plantilla.value = "";
        plantillaDocumento = documento || "";
        idRedSocial = id;
        setCamposDelFormulario(copiaDeCampos);
    }

    const obtenerLogo = async () => {

        let respuesta = await dispatch(obtenerRegistrosPorURL({ controller: fomularioDeRedesSociales, saveInStore: false, nombreDelMetodo: "obtenerImagenDeEmpresa", parametro: datosDeEmpresaGlobal?.nit}));

        setcargandoSolicitud(false);

        if(respuesta?.error) return changeDataResponse('error', respuesta?.error?.message || "No encontramos información del documento", true)

        if(!respuesta?.data ) return changeDataResponse('error', "No encontramos información del documento", true)

        setBase64Imagen(respuesta.data)
        setMostrarLogo(true)
    }

    const cerrarModalDeImagen = () => setMostrarLogo(false)

    const descargarPautaIngreasada = ( ) => plantillaDocumento ? functions.descargarBase64EnPDF(plantillaDocumento, "PAUTA_DIGITAL_META_INGRESADA.xlsx") : alertaPersonalizadaSwal( "¡No ha registro información!",'')
    ;

    const [camposDelFormulario, setCamposDelFormulario] = React.useState({
        datosDeLaPagina:{
            idelement: "datosDeLaPagina", title: `Registro de página de ${redSocial?.toUpperCase()}`, position:"center", elementType:'titulo', showTitleForm: true, name: "datosDeLaPagina", value: "", isError:false,
        },
        nombrePagina: {
            idelement: "nombrePagina", value: "", label: "Nombre de la página", pattern:"^[\\w\\s\\á-úÁ-Ú\\-\\,.#_“”]{4,70}$", validators: ['required'], errorMessages:['El campo nombre es requerido'], isError:false, elementType:'texto', name:"nombrePagina", 'disabled': false, keyPress: undefined, width: "33%", autofocus: true
        },
        urlPagina: {
            idelement: "urlPagina", value: "", label: "URL de la página", pattern:"^https?:\/\/[\w\-]+(\.[\w\-]+)+[/#?]?.*$", validators: ['required'], errorMessages:['El campo url es requerido'], isError:false, elementType:'texto', name:"urlPagina", 'disabled': false, keyPress: undefined, width: "33%", autofocus: false
        },
        correoElectronico: {
            idelement: "correoElectronico", value: "", label: "Correo electrónico *", pattern:"^[\\wA-Z0-9._%+-]+@[\\wA-Z0-9.-]+\\.\\w{2,4}$", validators: ['required'], errorMessages:['Ingrese un correo válido'], isError:false, elementType:'texto', name:"correoElectronico", width: "33%",
        },
        datosDelAdministrador:{
            idelement: "datosDelAdministrador", title:'Datos del administrador', position:"center", elementType:'titulo', showTitleForm: true, name: "datosDelAdministrador", value: "", isError:false,
        },
        cui:{
            idelement: "cui", value: "", label: "Ingrese CUI del DPI", pattern:"^[0-9]{13}$", validators: ['required'],
            errorMessages:['Numérico de 13 digitos'], isError:false, elementType:'texto','disabled':false, autofocus: false, keyPress: undefined, maxLength: 13, name:"cui", width: "50%",
        },
        nombreCompleto: {
            idelement: "nombreCompleto", value: "", label: "Nombre completo del administrador *", pattern:"^[\\w\\s\\á-úÁ-Ú\\-\\,.#_“”]{4,70}$", validators: ['required'], errorMessages:['El campo es requerido'], isError:false, elementType:'texto', name:"nombreCompleto", 'disabled': false, width: "50%",
        },
        plantilla:{
            idelement: "plantilla", title:'Cargar plantilla llena de los requisitos de medios alternos', position:"center", elementType:'titulo', showTitleForm: true, name: "plantilla", value: "", isError:false,
        },
        plantilla:{
            idelement: "plantilla", value: "", label: "Plantilla (Máximo 5 MB)",
            validators: {required: true, size: "5 MB",}, errorMessages: 'Por favor debe adjuntar lo solicitado', isError:false, elementType:'archivo','disabled': false, name:"plantilla", fileWidth: true, src: '/menu/Iconos Sistema SIDI_Mesa de trabajo 1 copia 23.png', multiple: false, accept:".xlsx", showInMovil: true, type: "file", showButtonEditDocument: true, firstTitle: "Plantilla", iconButton: <Visibility />, handleVisualization: obtenerLogo,  fileType: "png", nameOfFile: ""
        },
        boton:{
            idelement: "boton", elementType:'boton', name: "boton", value: "", isError:false, icon: "cloud_download", handleFunction: descargarPautaIngreasada, title: "Descargar pauta digital meta ingresada", color: "#205690"
        },
        acciones:{
            idelement: "acciones", title:'Acciones', position:"center", elementType:'titulo', showTitleForm: true, name: "acciones", value: "", isError:false,
        },
    });

    const cancelAction = () => history.goBack('/')

    const guardarDatos = async (dataForm) => {
        setcargandoSolicitud(true);

        const { nombrePagina, urlPagina, correoElectronico, cui, nombreCompleto, plantilla } = dataForm;

        const datosAGuardar = {
            nombrePagina,
            urlPagina,
            "email": correoElectronico,
            "cuiAdmin": cui,
            "nombreAdmin": nombreCompleto,
            documento: plantilla,
            "tipoRedSocial": redSocial === 'facebook' ? 1: 2,
        };
        let datosAEnviar = {};
        let respuesta = {};

        if(idRedSocial) {
            datosAEnviar = { controller: fomularioDeRedesSociales, action: "editar", data: datosAGuardar, nombreDelMetodo: `editar/${idRedSocial}` };
            respuesta = await dispatch(nuevoOActualizarRegistroPersonalizado(datosAEnviar));
        } else {
            datosAEnviar = { controller: fomularioDeRedesSociales, action: "crear", data: datosAGuardar, nombreDelMetodo: "" };
            respuesta = await dispatch(nuevoOActualizarRegistroPersonalizado(datosAEnviar));
        }

        setcargandoSolicitud(false);
        if(respuesta?.error) return alertaPersonalizadaSwal(respuesta?.error?.message || "No se puedo guardar los datos, intente nuevamente!",'')

        alertaPersonalizadaSwal(respuesta?.data || "Datos guardados correctamente", "", "success")
    }

    const [buttonList]= React.useState({
        "saveData":{"label":  "Guardar Datos", "icon": <NavigateNext />, "callback":guardarDatos,"loading":false,"size":"medium",
                "background":"linear-gradient(45deg, #205690 30%, #3890EE 90%)", "border":"0px", "borderRadius":"3",
                "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px", disabled: false,
                isCancel: false,
        },
        "cancelAction":{"label":"Salir", "icon": <NavigateNext />,"callback":cancelAction,"loading":false,"size":"medium",
                "background":"linear-gradient(45deg, #B90000 30%, #E07777 90%)", "border":"0px", "borderRadius":"3",
                "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px",  disabled: false,
                isCancel: true,
        },
    });

    const handClose = (_, reason) => {
        if (reason === 'clickaway') {return}
        changeDataResponse('error', '', false)
    };

    const descargarPlantilla = () => {
        console.log("redSocial", redSocial)
        if(redSocial === 'facebook') functions.descargarBase64EnPDF(redesSociales.facebook, "REPORTE_DE_PAUTA_DIGITAL_META_FACEBOOK.xlsx")
        if(redSocial === 'instagram') functions.descargarBase64EnPDF(redesSociales.instagram, "REPORTE_DE_PAUTA_DIGITAL_META_INSTAGRAM.xlsx")
    }

    const changeDataResponse = (tipoDeAlerta, mensajeDeAlerta, mostrarRespuesta = false) => setDatosDeRespuesta({tipoDeAlerta, mensajeDeAlerta, mostrarRespuesta,})

    const { tipoDeAlerta, mensajeDeAlerta, mostrarRespuesta} = datosDeRespuesta;
    const {checkearAutorizacion, autorizado, cargando} = validarDatos;

    if (checkearAutorizacion ) return <IndicadorDeCarga open={cargando}/>
    if (!autorizado && !cargando){ return <NoAutorizado />}

    return (
        <Fragment>
            {cargandoSolicitud ? <IndicadorDeCarga open={cargandoSolicitud} /> : '' }
            <AlertaDeRespuesta type={tipoDeAlerta} content={mensajeDeAlerta} open={mostrarRespuesta} handClose={handClose}/>
            <TituloConIcono
                title={`Redes Sociales -${redSocial?.toUpperCase() || ""}-`}
                titleButton1="Descargar reporte de pauta digital" titleButton2=""
                handleClickButton1={() => descargarPlantilla(1)}
                handleClickButton2={undefined}
                icon={"Iconos Sistema SIDI_Mesa de trabajo 1 copia 23"}
                widthIcon="90px" heighIcont="80px"
            />
            <Card>
                <CardContent>
                    <Formulario
                        elements={camposDelFormulario}
                        buttonList={buttonList}
                    />
                </CardContent>
            </Card>
            {mostrarLogo && (
                <ModalDeImagen base64={base64Imagen} title={"Plantilla de requisitos"} open={mostrarLogo} handleClose={cerrarModalDeImagen} showDownloadButton={false} src={base64Imagen} />
            )}
        </Fragment>
    );
}

export default RedesSociales;